/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {useState} from 'react';
import {MaterialFilledBackIcon} from '@ion/dls/src/icons/MaterialFilledBackIcon';
import {MaterialFilledForwardIcon} from '@ion/dls/src/icons/MaterialFilledForwardIcon';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {Color, IconSize, NavigationIconDirectionEnum} from '../types/types';

type Props = {
  direction?: keyof typeof NavigationIconDirectionEnum;
  isActive?: boolean;
  color?: Color;
};

/**
 * @NavigationIcon
 *
 * Grey Icon for Back Navigation
 *
 * ```typescript
 * import React from 'react';
 * import { NavigationIcon } from '@ion/dls/src/icons/';
 *
 * function MyComponent {
 *   return (
 *     <>
 *       <NavigationIcon />
 *       <NavigationIcon direction="forward" />
 *     </>
 *   );
 * }
 *
 * ```
 *
 */
export const NavigationIcon = ({
  isActive,
  color,
  direction = 'back'
}: Props) => {
  const [isMouseOver, setIsMouseOver] = useState(false);
  const [isMouseDown, setIsMouseDown] = useState(false);

  function getColor(isMouseDown, isMouseOver) {
    return isMouseDown ? dlsColor('grey1') : isMouseOver ? dlsColor('grey1')
      : isActive ? dlsColor('grey1') : dlsColor('grey3');
  }

  const iconProps = {
    size  : IconSize.large,
    color : color || getColor(isMouseDown, isMouseOver)
  };

  return (
    <span onMouseLeave={function() {
      setIsMouseOver(false);
    }} onMouseDown={function() {
      setIsMouseDown(true);
    }} onMouseUp={function() {
      setIsMouseDown(false);
    }} onMouseEnter={function() {
      setIsMouseOver(true);
    }}>
      {direction === 'back' && <MaterialFilledBackIcon {...iconProps} />}
      {direction === 'forward' && <MaterialFilledForwardIcon {...iconProps} />}
    </span>
  );
};
